import React from 'react';
import {connect} from "react-redux";
import '../login.css'
import {Form, Input, Button, Space, Select, Checkbox,AutoComplete} from 'antd';
import {Row, Col} from 'antd';
import {UserOutlined, HomeOutlined, AuditOutlined} from '@ant-design/icons';
import {setUserProfile} from '../reducer/userReducer'
import {Link, Redirect} from 'react-router-dom'
import Footer from './footer'

class Login extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {user, setUserProfile} = this.props
        console.log(this.props)
        const onFinish = (values) => {
            async function check(strName, intRoom) {
                var result = await fetch(API_URL + '/check',{
                    //mode:'cors',
                    method:'POST',
                    body:JSON.stringify({
                        name:strName,
                        room:intRoom,
                    }),
                    headers:{
                        'Content-type': 'application/json; charset=UTF-8',
                    },
                })
                return  result.json()
            }
            check(values.name, parseInt(values.room)).then(data=>{
                if (data.code == 200) {
                    console.log("finish values",values.name, values.room)
                    const state = setUserProfile(values)
                    console.log(state)
                    this.props.history.push('/home')
                }else{
                    alert('账户已经过期，请微信联系管理员')
                }
            })

        };

        const onFinishFailed = (errorInfo) => {
            console.log('Failed:', errorInfo);
        };

        return (
            <div className="account-form">
                <Row type="flex" justify="center" align="middle" style={{minHeight: '70vh'}}>
                    <Col>
                        <Form
                            initialValues={{
                                isAgree: true,
                            }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete="off"
                        >
                            <Space>
                                <Form.Item
                                    name={"name"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "请输入您的名字"
                                        },
                                        {
                                            type: "string",
                                            min: 4,
                                            max: 8,
                                            message: "4~8个字符,可使用数字和字母"
                                        }
                                    ]}
                                >
                                    <Input maxLength="16" placeholder="昵称" prefix={<UserOutlined/>}/>
                                </Form.Item>
                                <Form.Item
                                    name={"room"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "请输入您的房间"
                                        },
                                        {
                                            type: "string",
                                            min: 4,
                                            max: 8,
                                            message: "4~8个字符,可使用数字和字母"
                                        }
                                    ]}
                                >
                                    <Input maxLength="16" placeholder="房间号" prefix={<HomeOutlined/>}/>
                                </Form.Item>
                            </Space>
                            <Form.Item
                                name="isAgree"
                                valuePropName="checked"
                                rules={[
                                    {
                                        validator: (_, value) =>
                                            value ? Promise.resolve() : Promise.reject(new Error('请同意相关条款')),
                                    },
                                ]}
                            >
                                <Checkbox>
                                    同意<Link to="/argreement">《服务条款》</Link>、<Link to="/policy">《隐私政策》</Link>
                                </Checkbox>
                            </Form.Item>
                            <Button type="primary" htmlType="submit" block>
                                进入
                            </Button>
                        </Form>
                    </Col>
                </Row>
                <Row type="flex" justify="center" align="bottom" style={{minHeight: '30vh'}}>
                    <Col><Footer /></Col>
                </Row>
            </div>
        )
    }

}

const mapStateToProps = store => ({
    user:store.user
});

const mapDispatchToProps = dispatch => ({
    setUserProfile:(payload)=>dispatch(setUserProfile(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(Login)